import useAppContext from 'flow/hooks/useAppContext';
import CardCallDetailsContainer from 'flow/components/pbx/v2/misc/CardCallDetailsContainer';
import SectionTitle from 'flow/components/pbx/v2/detail-page/SectionTitle';
import SkeletonSummary from './SkeletonSummary';

const CardTranscriptionFetching = () => {
    const { i18next } = useAppContext();

    return (
        <CardCallDetailsContainer className="flex-col gap-3">
            <SectionTitle title={i18next.t('ai.summary.summary')} />
            <SkeletonSummary />
        </CardCallDetailsContainer>
    );
};

export default CardTranscriptionFetching;
